const ANIMATION_CLASSES = [
  'anim-reveal',
  'anim-reveal-fade',
  'anim-reveal-left',
  'anim-reveal-scale',
];

export function initScrollAnimations(): void {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Make all animated elements immediately visible
    ANIMATION_CLASSES.forEach(cls => {
      document.querySelectorAll(`.${cls}`).forEach(el => {
        el.classList.add('visible');
      });
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  ANIMATION_CLASSES.forEach(cls => {
    document.querySelectorAll(`.${cls}`).forEach(el => {
      observer.observe(el);
    });
  });
}
